import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import MainWrapper from "../../../MainWrapper";
import { Link, useNavigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back } from 'react-icons-kit/md';
import { Table, Button, Form } from "react-bootstrap";
import Loader from "../../../layouts/Loader";
import axios from "axios";
import { API_URL } from "../../../../config";
import { toast } from 'react-toastify';

const SEGMENTS = [
  { label: "0-50",     segmentMin: 0,   segmentMax: 50  },
  { label: "51-149",   segmentMin: 51,  segmentMax: 149 },
  { label: "150-299",  segmentMin: 150, segmentMax: 299 },
  { label: "300-399",  segmentMin: 300, segmentMax: 399 },
  { label: "400+",     segmentMin: 400, segmentMax: null },
];
const QUARTERS = [
  { label: "Q1", value: 1 },
  { label: "Q2", value: 2 },
  { label: "Q3", value: 3 },
  { label: "Q4", value: 4 },
];

const buildDefaultGrid = () => {
  const grid = {};
  SEGMENTS.forEach((seg) => {
    QUARTERS.forEach((q) => {
      grid[`${seg.segmentMin}_${q.value}`] = "";
    });
  });
  return grid;
};

const LostCustomer = ({ auth: { auth, isAuthenticated } }) => {
  const [grid, setGrid] = useState(buildDefaultGrid());
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }
    setLoading(true);
    axios
      .get(`${API_URL}/User/api/LostCustomerParameter/GetParameters`, {
        headers: { Authorization: `Bearer ${auth[0].token}` },
      })
      .then((res) => {
        const rows = Array.isArray(res.data) ? res.data : ((res.data && res.data.result) || []);
        if (rows.length > 0) {
          const newGrid = buildDefaultGrid();
          console.log('---111----', newGrid)
          rows.forEach((row) => {
            console.log('---row---', row)
            const key = `${row.segmentMin}_${row.quarter}`;
            if (Object.prototype.hasOwnProperty.call(newGrid, key)) {
              console.log('---key--', key)
              newGrid[key] = row.thresholdDays ?? "";
            }
          });
          console.log('---newGrid---', newGrid)
          setGrid(newGrid);
        }
      })
      .catch((err) => {
        console.warn("Could not load Lost Customer Parameters:", err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCellChange = (segmentMin, quarter, value) => {
    const key = `${segmentMin}_${quarter}`;
    if (value !== "" && !/^\d+$/.test(value)) {
      setFieldErrors((prev) => ({ ...prev, [key]: "Only numbers are allowed." }));
    } else {
      setFieldErrors((prev) => { const next = { ...prev }; delete next[key]; return next; });
    }
    setGrid((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please fix the highlighted fields before saving.");
      return;
    }
    const parameters = [];
    let hasError = false;

    SEGMENTS.forEach((seg) => {
      QUARTERS.forEach((q) => {
        const raw = grid[`${seg.segmentMin}_${q.value}`];
        if (raw !== "" && raw !== null && raw !== undefined) {
          const num = parseInt(raw, 10);
          if (!Number.isFinite(num) || num < 0) {
            toast.error(`Invalid value for segment ${seg.label} / ${q.label}. Must be a non-negative integer.`);
            hasError = true;
          } else {
            parameters.push({
              lostCustomerParameterId: seg.lostCustomerParameterId,
              segmentMin:   seg.segmentMin,
              segmentMax:   seg.segmentMax,
              segmentLabel: seg.label,
              quarter:      q.value,
              thresholdDays: num,
            });
          }
        } else {
          parameters.push({
            lostCustomerParameterId: seg.lostCustomerParameterId,
            segmentMin:   seg.segmentMin,
            segmentMax:   seg.segmentMax,
            segmentLabel: seg.label,
            quarter:      q.value,
            thresholdDays: null,
          });
        }
      });
    });

    if (hasError) return;

    setSaving(true);
    axios
      .post(
        `${API_URL}/User/api/LostCustomerParameter/SaveParameters?userId=${auth[0].userId}`,
        { parameters},
        { headers: { Authorization: `Bearer ${auth[0].token}` } }
      )
      .then(() => {
        toast.success("Lost Customer Parameters saved successfully.");
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.responsestatus) ||
          err.message;
        toast.error(`Save failed: ${msg}`);
      })
      .finally(() => setSaving(false));
  };

  return (
    <Fragment>
      <MainWrapper>
        <Loader loading={loading}>
          <div className="container">
            <div className="sub-header mt-5 mb-3">
              <h2>Lost Customer Parameters</h2>
              <Link className="btn btn-primary me-1" to="/admin">
                <Icon icon={ic_arrow_back} />Back
              </Link>
            </div>

            <div className="d-flex justify-content-center">
              <div className="border rounded p-4 bg-white" style={{ maxWidth: "700px", width: "100%" }}>
                <h4 className="text-center mb-4">Lost Customer Parameters</h4>
                <Table bordered responsive>
                  <thead>
                    <tr>
                      <th rowSpan={2}>
                        <strong>Segment</strong>
                      </th>
                      <th colSpan={4} className="text-center">
                        <strong>Days Since Last Order Threshold</strong>
                      </th>
                    </tr>
                    <tr>
                      {QUARTERS.map((q) => (
                        <th key={q.value} className="text-center">
                          <strong>{q.label}</strong>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {SEGMENTS.map((seg) => (
                      <tr key={seg.segmentMin}>
                        <td>{seg.label}</td>
                        {QUARTERS.map((q) => {
                          const key = `${seg.segmentMin}_${q.value}`;
                          const hasError = !!fieldErrors[key];
                          return (
                            <td key={q.value}>{key}
                              <Form.Control
                                type="text"
                                value={grid[key]}
                                onChange={(e) => handleCellChange(seg.segmentMin, q.value, e.target.value)}
                                isInvalid={hasError}
                                style={{ width: "80px" }}
                              />
                              {hasError && (
                                <Form.Control.Feedback type="invalid" style={{ display: "block", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                                  Numbers only
                                </Form.Control.Feedback>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-end mt-3">
                  <Button variant="primary" onClick={handleSave} disabled={saving}>
                    {saving ? "Saving…" : "Save"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Loader>
      </MainWrapper>
    </Fragment>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(LostCustomer);
